import { memo } from "react"

import { Col, Row } from "react-bootstrap"

import NotificationGridRow from "./NotificationGridRow"
import NotificationContactData from "../../../api/Randoms/Notification/NotificationContactData"
import { useNotificationContacts } from "../../../api/Randoms/Notification/useNotificationContacts"
import { useNotificationContactsActions } from "../../../api/Randoms/Notification/useNotificationContactsActions"
import Checkbox from "../../Checkbox"
import LoadingTableBodyWrapper from "../../LoadingTableBodyWrapper"
import LoadingTableWrapper from "../../LoadingTableWrapper"
import TablePagination from "../../TablePagination"

function NotificationGrid() {
  const { loadingContacts, gridData } = useNotificationContacts()
  const { page$, selectContacts } = useNotificationContactsActions()

  const handleSelectAllContacts = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target
    const contactIds = gridData.Records.map((record: NotificationContactData) => record.ContactID)

    selectContacts(contactIds, checked)
  }

  const isAllContactSelected = () => {
    return (
      gridData?.Records?.length > 0 && gridData?.Records.every((record: NotificationContactData) => record.selected)
    )
  }

  const handleChangePage = (page: number) => {
    page$.next({ ...page$.value, PageNumber: page })
  }

  return (
    <LoadingTableWrapper loading={loadingContacts} variant="light" withHeader>
      <table className="table table-bordered table-responsive">
        <thead className="thead-light text-nowrap text-uppercase">
          <tr>
            <th className="text-center col-auto px-0">
              <Checkbox
                id="all_contacts"
                disabled={loadingContacts || (gridData?.Records?.length ?? 0) === 0}
                checked={isAllContactSelected()}
                onChange={handleSelectAllContacts}
              />
            </th>
            <th>Name</th>
            <th className="col-2">Email address</th>
            <th className="col-1">Phone number</th>
            <th className="text-center col-1">Notify by</th>
            <th className="col-3">Notification types</th>
            <th className="col-1 text-center">Mode</th>
            <th className="col-1 text-center">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-light">
          <LoadingTableBodyWrapper
            loading={loadingContacts}
            recordsCount={gridData?.Records?.length || 0}
            columnsCount={8}
            noDataText="No contacts found"
          >
            {gridData.Records.map((record: NotificationContactData) => (
              <NotificationGridRow key={`nc_${record.ContactID}`} contact={record} />
            ))}
          </LoadingTableBodyWrapper>
        </tbody>
      </table>
      {gridData?.Records?.length > 0 && (
        <Row>
          <Col sm={2}>Total records: {gridData.Total}</Col>
          <Col>
            <TablePagination pageNumber={page$.value.PageNumber} pages={gridData.Pages} onChange={handleChangePage} />
          </Col>
        </Row>
      )}
    </LoadingTableWrapper>
  )
}

export default memo(NotificationGrid)
